import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3;
import React, { useContext } from 'react';
import * as themes from '@uiw/codemirror-themes-all';
import CodeMirror from '@uiw/react-codemirror';
import { langs } from '@uiw/codemirror-extensions-langs';
import styled from 'styled-components';
import { Context } from '../../store/content';
import { CheckIcon } from '../icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0.5rem 0.5rem 0.5rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  gap: 0.5rem;\n"])));
var ThemeSample = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 0.3rem;\n  &::after {\n    content: ' ';\n    display: block;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    cursor: pointer;\n    background-color: var(--color-ci-btn-hover-bg);\n    border-radius: 0.2rem;\n    opacity: 0;\n    transition: all 0.2s;\n  }\n  &:hover::after {\n    opacity: 0.1;\n  }\n  &:active::after {\n    opacity: 0.3;\n  }\n"])));
var Header = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  background-color: var(--color-ci-btn-bg);\n  border-radius: 0.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.1rem 0.3rem;\n  margin-bottom: 0.3rem;\n  position: sticky;\n  z-index: 9;\n  top: 0;\n"])));
var sampleCode = "import React from 'react';\n\nexport function Demo() {\n  return <div>Oh!</div>;\n}";
var basicSetup = {
  foldGutter: false
};
export var ThemeView = () => {
  var {
    setTheme,
    theme
  } = useContext(Context);
  var handleClick = ev => {
    setTheme(ev.currentTarget.dataset.theme);
  };
  var themeName = Object.keys(themes).filter(name => !/(^defaultSettings|Init$)/.test(name));
  return /*#__PURE__*/_jsx(Wrapper, {
    children: themeName.map((keyName, index) => {
      return /*#__PURE__*/_jsxs(ThemeSample, {
        "data-theme": keyName,
        onClick: handleClick,
        children: [/*#__PURE__*/_jsxs(Header, {
          children: [keyName, keyName === theme && /*#__PURE__*/_jsx(CheckIcon, {
            width: 15,
            height: 15,
            fill: "#4caf7c"
          })]
        }), /*#__PURE__*/_jsx(CodeMirror, {
          value: sampleCode,
          basicSetup: basicSetup,
          editable: false,
          extensions: [langs.jsx()],
          theme: themes[keyName]
        })]
      }, index);
    })
  });
};